import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        lang: undefined, // 语言
        // version: "v3",// 版本
        // version: "v3.20.1220",
        version: undefined
    },
    mutations: {
        setLang(state, { lang, i18n }) {
            state.lang = lang;
            i18n.locale = lang;
        },
        setVersion(state, version) {
            state.version = version;
        }
    },
    actions: {}
});



// WEBPACK FOOTER //
// ./src/store.js